export default __webpack_public_path__ + "static/media/opentech-screenshots.1fcef358.jpg";